import React, { FC, FormEvent } from "react";

import { toast } from "react-toastify";

import {
  useApisMembersBookmarkedKnowledgeInsightPostsBookmarkFolderMovesUpdate,
  useApisMembersKnowledgeInsightPostsBookmarksShow,
  useApisMembersKnowledgeInsightPostBookmarkFoldersIndex,
  useInput,
} from "~/hooks";

import { BookmarkMoveModal } from "./BookmarkMoveModal";

type PropsType = {
  onClose: () => void;
  knowledgeInsightPostId: string;
};

export const KnowledgeInsightPostBookmarkMoveModal: FC<PropsType> = ({
  onClose,
  knowledgeInsightPostId,
}: PropsType) => {
  useApisMembersKnowledgeInsightPostsBookmarksShow({
    knowledgeInsightPostId: knowledgeInsightPostId,
    config: {
      onSuccess: (data) => {
        setBookmarkFolderId(data.bookmarkFolder?.id);
      },
    },
  });
  const { data: bookmarkFoldersIndex } =
    useApisMembersKnowledgeInsightPostBookmarkFoldersIndex();
  const [
    { value: bookmarkFolderId, onChange: onChangeBookmarkFolderId },
    setBookmarkFolderId,
  ] = useInput("");

  const { mutate } =
    useApisMembersBookmarkedKnowledgeInsightPostsBookmarkFolderMovesUpdate();

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    mutate(
      {
        knowledgeInsightPostId: knowledgeInsightPostId,
        body: { bookmarkFolderId },
      },
      {
        onSuccess: (data) => {
          toast(data.message);
          onClose();
        },
      },
    );
  };

  return (
    <BookmarkMoveModal
      onClose={onClose}
      bookmarkFolders={bookmarkFoldersIndex?.bookmarkFolders || []}
      bookmarkFolderId={bookmarkFolderId}
      onChangeBookmarkFolderId={onChangeBookmarkFolderId}
      onSubmit={onSubmit}
    />
  );
};
